import en from './en';
import zh from './zh';
import es from './es';
import tw from './zh-tw';

export default {
  en,
  zh,
  es,
  'zh-tw': tw,
};
